import { useEffect } from "react";
import Footer from "../../reusableUi/Footer";
import ServicesHero from "./components/ServicesHero";
import ServicesMain from "./components/ServicesMain";
export default function ServicesPage() {
  useEffect(() => {
    document.title =
      "Plumbing Services in Chicago | Drain, Leak & Water Heater Repair";

    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Professional plumbing services in Chicago including drain cleaning, leak detection, and water heater service. Licensed and fast response.",
      );
    }
  }, []);
  return (
    <div className="space-y-26">
      
      
      <ServicesHero />
      <ServicesMain />
      <Footer />
    </div>
  );
}
